import * as React from "react";
import { Switch } from "@fluentui/react-components";

// Fully controlled — no local `checked` state. A previous version tracked
// its own state and only re-synced via a useEffect keyed on `itemChecked`,
// so a caller whose update failed (itemChecked never actually changed)
// left the switch visually stuck on the user's click forever, since the
// prop it watched for never changed either. Always rendering the prop
// directly means a failed update simply never visually moves it in the
// first place — correct by construction, not by a reset path.
export const SwitchButton = (props: any) => {
  return (
    <Switch
      value={props.label}
      checked={props.itemChecked !== undefined ? props.itemChecked : false}
      onChange={(ev) => {
        props.onChange(ev.target.value);
      }}
      label={props.label ? props.label : ""}
      labelPosition={props.labelPosition ? props.labelPosition : undefined}
      disabled={props.disabled ? props.disabled : undefined}
    />
  );
};
